/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import { IStackStyles, IStackTokens } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';

import { FontSizes } from '../../../../../styles/teams';
import { TemplateIconStyles } from '../../../../common/TemplateIcon';

export const getStackStyles = (theme: ITheme): Partial<IStackStyles> => {
    return {
        root: {
            selectors: {
                '.template-instance-fields div:not(.error-label)>.ms-Label:not(.inner-error-label)': {
                    fontSize: FontSizes.size14,
                    color: theme.palette.black + ' !important',
                    fontWeight: 'bold',
                },

                '.template-instance-fields > div': {
                    marginBottom: '1.25rem',
                },
                '.details-field': {
                    width: '38.5rem',
                    marginBottom: '1.25rem',
                },
                '.approvers-people-picker': {
                    maxWidth: '38.5rem',
                    marginTop: '-0.75rem',
                },
                '.template-label': {
                    fontSize: FontSizes.size14,
                    color: theme.palette.black + ' !important',
                    fontWeight: 'bold',
                },
            },
        },
    };
};

export const getNameContainerStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            marginBottom: '1rem',
            selectors: {
                '.title-field': {
                    width: '32.25rem',
                },
            },
        },
    };
};

export const getIconStyles = (): TemplateIconStyles => {
    return {
        iconContainer: { height: '4rem', width: '4rem', borderRadius: '4px' },
        icon: { height: '2rem', width: '2rem', fontSize: FontSizes.size32 },
    };
};

export const getCategoryStyles = (): Partial<IDropdownStyles> => {
    return {
        root: {
            maxWidth: '18.375rem',
        },
    };
};

export const getStackTokens = (): Partial<IStackTokens> => {
    return { childrenGap: '1.25rem' };
};
